import React from 'react'
import { useState } from 'react'
import { finanseDropdown } from './Navitems'
import { Link } from 'react-router-dom'

function Dropdown() {
    const [dropdown, setDropdown] = useState(true);


  return (
    <>
        <ul className={dropdown ? 'absolute pt-[6px] pr-[6px]' : 'hidden'} onClick={() => setDropdown(!dropdown)}>
            {finanseDropdown.map((item) => (
                <li key={item.id} className='bg-white py-1 hover:scale-105 duration-500 px-2'>
                    <Link to={item.path} onClick={() => setDropdown(!dropdown)}>{item.title}</Link>
                </li>
            ))}
        </ul>
    </>
  )
}

export default Dropdown